import React from 'react'
import useSEO from "./useSEO";

const FusilAccounting = () => {

  useSEO({ 
    title: "Fusil Accounting Software | Smart Finance & Business Management",
    description: "Fusil Accounting Software helps businesses manage accounting, GST, billing, inventory, and financial reports with speed and accuracy.",
    keywords: "Fusil accounting software, business accounting system, GST accounting software, billing and inventory software, finance management tool",
    ogTitle: "Fusil Accounting Software - Complete Accounting Solution",
    ogDescription: "Simplify finance, GST, and reporting with Fusil Accounting Software.",
    ogImage: "img/fusil-accounting.png",
    twitterTitle: "Fusil Accounting Software",
    twitterDescription: "Modern accounting solution for growing businesses.",
    twitterImage: "img/fusil-accounting.png"
  });

  return (
    <div>

      <section className="pt-lg-8 pt-xl-9">
        <div className="container position-relative pt-4 pt-lg-0">
          <div className="row align-items-center">

            <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
              <h1 className="mb-4">Fusil Accounting Software</h1>

              <p className="mb-4">
                Fusil Accounting Software is an advanced financial management
                platform designed to help businesses streamline their accounting,
                taxation, billing, and inventory operations. Built with modern
                technology and an easy-to-use interface, Fusil enables companies
                to manage their finances efficiently while maintaining complete
                accuracy and compliance.
              </p>

              <p>
                Whether you are a startup, SME, or large enterprise, Fusil
                provides powerful tools to automate accounting tasks, monitor
                cash flow, generate financial reports, and improve decision
                making. With real-time insights and scalable features, Fusil
                supports business growth at every stage.
              </p>
            </div>

            <div className="col-md-5 ms-auto">
              <img
                src="img/fusil-accounting-.png"
                alt="Fusil Accounting Software"
              />
            </div>

          </div>
        </div>
      </section>


      <section className="overflow-hidden pb-0">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
              <div className="pe-lg-6 pe-xl-8">
                <img
                  src="img/fusil-accounting.png"
                  alt="Fusil Accounting Dashboard"
                />
              </div>
            </div>

            <div className="col-lg-6 ms-auto">

              <h2 className="mb-lg-4">Key Features</h2>
              <hr className="my-4 my-lg-5" />

              <ul className="list-group list-group-borderless">

                <li className="list-group-item fw-normal d-flex">
                  <i className="bi bi-patch-check text-primary me-2" />
                  <b>Complete Accounting Management</b>
                </li>
                <p>
                  Manage general ledger, receivables, payables, journal
                  entries, and bank reconciliation with a centralized system.
                </p>

                <li className="list-group-item fw-normal d-flex">
                  <i className="bi bi-patch-check text-primary me-2" />
                  <b>GST & Tax Automation</b>
                </li>
                <p>
                  Automatically generate GST invoices, track tax liabilities,
                  and simplify compliance with accurate reporting.
                </p>

                <li className="list-group-item fw-normal d-flex">
                  <i className="bi bi-patch-check text-primary me-2" />
                  <b>Inventory & Billing System</b>
                </li>
                <p>
                  Monitor stock levels, manage suppliers, automate purchase
                  and sales orders, and streamline billing processes.
                </p>

                <li className="list-group-item fw-normal d-flex">
                  <i className="bi bi-patch-check text-primary me-2" />
                  <b>Multi-User Access</b>
                </li>
                <p>
                  Secure financial information with role-based permissions
                  and controlled system access.
                </p>

                <li className="list-group-item fw-normal d-flex">
                  <i className="bi bi-patch-check text-primary me-2" />
                  <b>Financial Reports</b>
                </li>
                <p>
                  Generate detailed reports such as Profit & Loss, Balance
                  Sheet, Trial Balance, Cash Flow, and tax summaries instantly.
                </p>

                <li className="list-group-item fw-normal d-flex">
                  <i className="bi bi-patch-check text-primary me-2" />
                  <b>Smart Dashboard</b>
                </li>
                <p>
                  Visualize business performance with real-time financial
                  insights and key metrics in one dashboard.
                </p>

              </ul>

            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default FusilAccounting